import { Star, MailOpen, Layers, Eye } from "lucide-react";
import Badge from "../../../components/ui/Badge";
import TemplateSkeleton from "./template-skeleton";

const CATEGORY_TONE = {
  newsletter: "info",
  promotion: "danger",
  welcome: "success",
  reengagement: "high",
  transactional: "primary",
};

export default function TemplateCard({ template: t, onPreview, onToggleFav }) {
  return (
    <div
      className="group bg-surface border border-border rounded-xl overflow-hidden flex flex-col transition-all duration-200 hover:-translate-y-0.5"
      style={{ boxShadow: "0 1px 8px rgba(0,0,0,0.05)" }}
    >
      {/* Thumbnail */}
      <div className="relative p-4 pb-0" style={{ background: "var(--color-surface-alt)" }}>
        <button
          onClick={() => onToggleFav(t)}
          className="absolute top-3 right-3 z-10 w-7 h-7 rounded-full flex items-center justify-center bg-surface/80 backdrop-blur-sm border border-border transition-colors hover:bg-surface"
          title={t.favorite ? "Remove favorite" : "Add favorite"}
        >
          <Star
            className="w-3.5 h-3.5"
            style={{ color: t.favorite ? "var(--color-warning)" : "var(--color-text-muted)", fill: t.favorite ? "var(--color-warning)" : "transparent" }}
          />
        </button>

        <div className="h-40 overflow-hidden">
          <TemplateSkeleton blocks={t.blocks} accent={t.accent} compact />
        </div>

        {/* Hover preview overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" style={{ background: "rgba(0,0,0,0.35)" }}>
          <button
            onClick={() => onPreview(t)}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold text-white"
            style={{ background: "linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)" }}
          >
            <Eye className="w-4 h-4" /> Preview
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="text-sm font-semibold text-text_primary leading-tight">{t.name}</h3>
          <Badge tone={CATEGORY_TONE[t.category] ?? "neutral"}>
            {t.category.charAt(0).toUpperCase() + t.category.slice(1)}
          </Badge>
        </div>
        <p className="text-xs text-text_muted leading-snug flex-1">{t.description}</p>

        <div className="flex items-center gap-4 mt-3 pt-3 border-t border-border">
          <span className="inline-flex items-center gap-1 text-xs text-text_muted">
            <Layers className="w-3.5 h-3.5" /> {t.uses} uses
          </span>
          <span className="inline-flex items-center gap-1 text-xs text-text_muted">
            <MailOpen className="w-3.5 h-3.5" style={{ color: "var(--color-success)" }} /> {t.openRate}%
          </span>
        </div>
      </div>
    </div>
  );
}
